import http from '@/services/http';

const roles = {
  index(tableFilters) {
    return http.request({
      method: 'get',
      url: '/roles',
      params: { filter: { ...tableFilters } },
    });
  },
  count() {
    return http.request({
      method: 'get',
      url: '/roles/count',
    });
  },
  show(name) {
    return http.request({
      method: 'get',
      url: `/roles/${name}`,
    });
  },
  create(data) {
    return http.request({
      method: 'post',
      url: '/roles',
      data,
    });
  },
  patch(name, data) {
    return http.request({
      method: 'patch',
      url: `/roles/${name}`,
      data,
    });
  },
  autocompleteFetch(name) {
    const filter = {
      where: {
        name: {
          regexp: `/${name || ''}/i`,
        },
      },
    };
    return http.request({
      method: 'get',
      url: '/roles',
      params: {
        filter,
      },
    });
  },
};

export default roles;
